module.exports = __webpack_public_path__ + "static/img/bianzu3.943aabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bianzu3.png
// module id = bN6A
// module chunks = 2